<div
  class="keyboard grid-container"
  [ngClass]="dataClass + (fitWidth ? 'keyboard-fit' : '')"
  [attr.data-right]="dataRight"
  [attr.data-left]="dataLeft"
  [attr.data-blocked]="isBlocked"
>
  <h1 aria-hidden="true" id="parentTitle" *ngIf="parentDescriptionEnabled" style="display: none;">{{parentDescription}}</h1>
  <div class="grid-container-row" *ngIf="showLetters">
    <button
      [attr.aria-label]="'spaceBar' | translate"
      class="keyboardLetter keys focusable-element spaceBar"
      data-down-index="0"
      (mouseover)="focusKey($event, keyboard.length, 0)"
      (focus)="manageKeyFocus()"
      (click)="getKeyValue('|______|')"
    ></button>
    <button
      [attr.aria-label]="'keyboard.clearAll' | translate"
      class="keyboardLetter keys focusable-element clearAll"
      data-down-index="2"
      (mouseover)="focusKey($event, keyboard.length, 1)"
      (click)="getKeyValue('Clear all')"
      (focus)="manageKeyFocus()"
    >
      {{ 'keyboard.clearAll' | translate }}
    </button>
    <button
    [attr.aria-label]="'backspace' | translate"
      class="keyboardLetter keys focusable-element backspace"
      data-down-index="4"
      role="none"
      (mouseover)="focusKey($event, keyboard.length, 2)"
      (click)="getKeyValue('⬅')"
      (focus)="manageKeyFocus()"
    ></button>
  </div>
  <div class="grid-container-row keyboard-grid" *ngFor="let row of keyboard; let cIndex = index">
    <button
      *ngFor="let key of row; let i = index"
      class="keyboardLetter focusable-element"
      [class.letterUppercase]="isUppercase &&  key !== '.com'"
      [ngClass]="{'bigKeyboardLetter': !showLetters && key === '0',
        'mediumKeyboardLetter': !showLetters || key === '.com',
        'backspace': key == '⬅',
        'number-backspace': key == '⬅' && !showLetters}"
      [attr.data-up-index]="key === 'a' || key === 'b' ?  '0' : (key === 'c' || key === 'd' ?  '1' : (key === 'e' || key === 'f' ?  '2' : ''))"
      (mouseover)="focusKey($event, cIndex, i)"
      (click)="getKeyValue(key)"
      [attr.aria-labelledby]="i === 0 ? 'parentTitle keylabel' + key : 'keylabel' + key"
      (focus)="manageKeyFocus()"
    >
      {{key}}
      <span [id]="'keylabel'+key" style="display: none;">{{key}}</span>
    </button>
  </div>
</div>
